export interface CartItem {
  productId: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
  weight: string;
}

export const getCart = (): any[] => {
  const cart = localStorage.getItem('cart-UniversalDairy');
  return cart ? JSON.parse(cart) : [];
};

export const getUser = (): any[] => {
  const cart = localStorage.getItem('UserData-UniversalDairy');
  return cart ? JSON.parse(cart) : [];
};

export const saveCart = (cart: any[]): void => {
  localStorage.setItem('cart-UniversalDairy', JSON.stringify(cart));
};

export const getAuthToken = (): any[] => {
  const cart = localStorage.getItem('loginData-UniversalDairy');
  return cart ? JSON.parse(cart) : [];
};

export const isInCart = (itemId: number, contractId: number) => {
  const cart = getCart();
  return cart.some(
    (item: any) =>
      item.ItemID === itemId &&
      item.ContractID === contractId
  );
};

export const addToCart = ({
  ItemID,
  ContractID,
  Qty,
}: {
  ItemID: number;
  ContractID: number;
  Qty: number;
}) => {
  const cart = getCart();

  const existingItem = cart.find(
    (item: any) =>
      item.ItemID === ItemID && item.ContractID === ContractID
  );

  if (existingItem) {
    existingItem.Qty += Qty;
  } else {
    cart.push({
      ItemID,
      ContractID,
      Qty,
    });
  }

  saveCart(cart);
  window.dispatchEvent(new Event("cartUpdated"));
};

export const updateCartItemQuantity = (
  productId: number,
  quantity: number
): void => {
  const cart = getCart();

  const item = cart.find(
    (item: any) => item.ItemID === productId
  );

  if (!item) return;

  if (quantity <= 0) {
    const updatedCart = cart.filter(
      (item: any) => item.ItemID !== productId
    );
    saveCart(updatedCart);
  } else {
    item.Qty = quantity;
    saveCart(cart);
  }

  window.dispatchEvent(new Event("cartUpdated"));
};


export const removeFromCart = (ItemID: number): void => {
  const cart = getCart();
  const updatedCart = cart.filter(item => item.ItemID !== ItemID);
  saveCart(updatedCart);
  window.dispatchEvent(new Event('cartUpdated'));
};

export const clearCart = (): void => {
  localStorage.removeItem('cart-UniversalDairy');
  window.dispatchEvent(new Event('cartUpdated'));
};

export const getCartTotal = (): number => {
  const cart = getCart();
  return cart.reduce((total, item) => total + (item.price * item.Qty), 0);
};

export const getCartItemCount = (): number => {
  const cart = getCart();
  return cart.reduce((count, item) => count + item.Qty, 0);
};

export const getCartQuantity = (itemId: number, contractId: number) => {
  const cart = getCart();

  const item = cart.find(
    (i: any) =>
      i.ItemID === itemId &&
      i.ContractID === contractId
  );

  return item ? item.Qty : 0;
};
